import { hasPagePermission } from '../authStorage';

export default function PagePermissionGuard({ moduleId, children }) {
  if (!hasPagePermission(moduleId)) {
    return (
      <div style={{ padding: 28, fontFamily: 'Cairo, sans-serif', color: '#78909c' }}>
        لا تملك صلاحية الوصول إلى هذه الصفحة.
      </div>
    );
  }
  return children;
}
